import React from 'react';

const BootstrapModalContext = React.createContext();

export default BootstrapModalContext;
